const SET_LOADER_STATE = 'SET_LOADER_STATE';

export {
  SET_LOADER_STATE
};
